module.exports = __webpack_public_path__ + "img/twitter.9d09fd21.svg";